<template>
    <div class="map-page">
      <app-map></app-map>
    </div>
</template>

<script>
  import Map from '../components/Map'
    export default {
        name: "MapPage",
        components: {
          'app-map': Map
        }
    }
</script>

<style scoped>

</style>
